// Module
var code = "<script>let $ctrl</script> <div class=\"flex justify-center\"> <molecule-form-checkbox ng-model=\"$ctrl.model\" label-text=\"{{ 'TR_200625-8ce66a_TR' | translate}}\" callback-on-click=\"$ctrl.toggle\" disabled=\"$ctrl.requestLoading\"></molecule-form-checkbox> </div> ";
// Exports
module.exports = code;